import { Badge } from "@/components/ui/badge";

const STATUS_MAP = {
  // Recordings/modules/notes
  belum_dimuat_naik: { label: "Not uploaded yet", classes: "bg-muted text-muted-foreground border-border" },
  tersedia: { label: "Available", classes: "bg-teal/10 text-teal border-teal/30" },
  disembunyikan: { label: "Hidden", classes: "bg-destructive/10 text-destructive border-destructive/30" },
  // Access
  active: { label: "Active", classes: "bg-teal/10 text-teal border-teal/30" },
  pending: { label: "Pending", classes: "bg-gold/10 text-gold border-gold/30" },
  expired: { label: "Expired", classes: "bg-destructive/10 text-destructive border-destructive/30" },
  // Categories
  percuma: { label: "Free", classes: "bg-teal/10 text-teal border-teal/30" },
  berbayar: { label: "Paid", classes: "bg-gold/10 text-gold border-gold/30" },
  // Event statuses
  upcoming: { label: "Upcoming", classes: "bg-blue-500/10 text-blue-400 border-blue-500/30 dark:text-blue-300" },
  open_registration: { label: "Open Registration", classes: "bg-teal/10 text-teal border-teal/30" },
  full: { label: "Full", classes: "bg-gold/10 text-gold border-gold/30" },
  closed: { label: "Closed", classes: "bg-muted text-muted-foreground border-border" },
  completed: { label: "Completed", classes: "bg-muted text-muted-foreground border-border" },
  cancelled: { label: "Cancelled", classes: "bg-destructive/10 text-destructive border-destructive/30" },
  // Visibility
  published: { label: "Published", classes: "bg-teal/10 text-teal border-teal/30" },
  draft: { label: "Draft", classes: "bg-muted text-muted-foreground border-border" },
  hidden: { label: "Hidden", classes: "bg-destructive/10 text-destructive border-destructive/30" },
  // Batches
  batch_active: { label: "Active", classes: "bg-teal/10 text-teal border-teal/30" },
};

export function StatusBadge({ status, label, className = "" }) {
  const s = STATUS_MAP[status] || { label: label || status || "Unknown", classes: "bg-muted text-muted-foreground border-border" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`status-pill ${s.classes} ${className}`}
    >
      {label || s.label}
    </span>
  );
}
